import {
  useTranslation as _useTranslation,
  type I18nTranslation,
} from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import { en } from './locale-en';
import { es } from './locale-es';
import { pt } from './locale-pt';
import type { TKeys } from './types';

export type { TKeys };

const locales: I18nTranslation = {
  en,
  es,
  pt,
};

export const useAddI18nLocales = () => {
  const { addResourceBundle } = _useTranslation();

  addResourceBundle(locales);
};

export const useTranslation = () => {
  const result = _useTranslation<TKeys>(PAGE_KEY);

  return result;
};
